import { H1, XStack, YStack } from 'tamagui';

interface ScreenHeaderProps {
  title: string;
  actions?: React.ReactNode;
}

export const ScreenHeader = ({
  title,
  actions,
}: ScreenHeaderProps): React.ReactElement => {
  return (
    <YStack gap="$3">
      <XStack justifyContent="space-between" alignItems="center">
        <H1 flexShrink={1}>{title}</H1>
        {actions}
      </XStack>
      <YStack height="$separator" backgroundColor="$color" />
    </YStack>
  );
};
